import React from 'react';
import { useSpeechSynthesis } from 'react-speech-kit';
import './SRead.css';

const ControlStudy = ({ setVoice, startReading, pauseReading, resumeReading }) => {
  const { voices } = useSpeechSynthesis();

  return (
    <div className="controls">
      <select onChange={(e) => setVoice(e.target.value)}>
        {voices.map((voice, index) => (
          <option key={index} value={voice.name}>
            {voice.name} ({voice.lang})
          </option>
        ))}
      </select>
      <button onClick={startReading}>Start Reading</button>
      <button onClick={pauseReading}>Pause Reading</button>
      <button onClick={resumeReading}>Resume Reading</button>
    </div>
  );
};

export default ControlStudy;